import type { IAppFeatures } from '__generated__';
import { baseApi } from 'store/api';
import { APIRead } from 'utils/api-client';

/** R-39 — a failed call or a missing field means the feature is off. */
const APP_FEATURES_FALLBACK: IAppFeatures = {
  includeMatrix: false,
  leadAnalystCommitteePositionId: null,
};

export const appFeaturesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppFeatures: builder.query<IAppFeatures, void>({
      async queryFn() {
        // The failure is cached as the fallback: the value never changes during a session, so no retry.
        try {
          const { data } = await APIRead.api.appFeaturesGetList();
          return {
            data: {
              includeMatrix: data?.includeMatrix === true,
              leadAnalystCommitteePositionId: data?.leadAnalystCommitteePositionId ?? null,
            },
          };
        } catch {
          return { data: APP_FEATURES_FALLBACK };
        }
      },
      // Per environment and fixed for the session: fetched once, never evicted, no polling.
      keepUnusedDataFor: Infinity,
    }),
  }),
});

export const { useGetAppFeaturesQuery } = appFeaturesApi;

export const prefetchAppFeatures = () =>
  appFeaturesApi.util.prefetch('getAppFeatures', undefined, {});
